import classNames from "classnames";
import Button from "components/Leasing/components/leasing.c.button";
import {
  prePareQueryRequest,
  getLastItem,
} from "components/Leasing/utils/leasing.u";
import { differenceInDays, format } from "date-fns";
import _ from "lodash";
import { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import API from "../api/api.main";
import { Auth } from "aws-amplify";
import axios from "axios";
import numeral from "numeral";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import { DateTime } from "luxon";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let source = axios.CancelToken.source();

function LeasingReportPayment({ month }) {
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [count, setCount] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (finished) {
      const doc = document.getElementById("export-excel-leasing-payment");
      doc.click();
    }
  }, [finished]);

  const fetchLeasingLoan = async (firstLoading = true) => {
    try {
      setLoading(firstLoading);
      setFinished(false);
      setCount(0);

      let datas = [];
      const rangeDates = [];
      const dateOfMonth = DateTime.fromJSDate(new Date(month)).daysInMonth;

      for (let index = 0; index < dateOfMonth; index++) {
        const date = DateTime.fromJSDate(new Date(month)).plus({ days: index });

        if (date >= DateTime.fromJSDate(new Date())) break;
        rangeDates.push(date.toFormat("yyyy-MM-dd"));
      }

      for (const rangeDate of rangeDates) {
        const data = await API.get("MoneyHubAdmin", `/leasing/loan/payment`, {
          queryStringParameters: {
            paid_date: getCurrentLocalDateTime(new Date(rangeDate)).fullDate,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
          cancelToken: source?.token,
        });

        datas = datas.concat(data?.payments);
        setCount(datas.length);
      }

      setPayments(datas);
      setFinished(true);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    console.log("data", data);

    for (let i = 0; i < data.length; i++) {
      var filled = { patternType: "solid", fgColor: { rgb: "FFFFFF" } };
      // i == data.length - 1
      //   ? { patternType: "solid", fgColor: { rgb: "FEFF54" } }
      //   : { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 =
        i == data.length - 1
          ? { fgColor: { rgb: "FFFFFF" } }
          : { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${i + 1 || ""}`,
          style: { font: { sz: 14 }, alignment: "right", fill: filled },
        },
        {
          value: data[i]?.startDueDate
            ? format(new Date(data[i]?.startDueDate), "dd-MM-yyyy")
            : "-",
          style: { font: { sz: 14 }, alignment: "right", fill: filled },
        },
        {
          value: data[i]?.endDueDate
            ? format(new Date(data[i]?.endDueDate), "dd-MM-yyyy")
            : "-",
          style: {
            font: { sz: 14 },
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.AR_CLEAR_DOC_DATE
            ? format(new Date(data[i]?.AR_CLEAR_DOC_DATE), "dd-MM-yyyy")
            : "-",
          style: {
            font: { sz: 14 },
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.fullname || "",
          style: {
            font: { sz: 14 },
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.REFERENCE || "",
          style: {
            font: { sz: 14 },
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.purpose || "",
          style: {
            font: { sz: 14 },
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value:
            {
              TRUCK: "รถกระบะ",
              MOTORBIKE: "รถจักรยานยนต์",
              CAR: "รถยนต์",
            }[data[i]?.type] || "",
          style: {
            font: { sz: 14 },
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: numeral(data[i]?.total + data[i]?.OVERPAID_AMOUNT || 0).format("0,000.00") || 0,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: numeral(
            data[i]?.AR_PAY_AMOUNT + data[i]?.OVERPAID_AMOUNT || 0
          ).format("0,000.00"),
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: numeral(data[i]?.INTEREST_AMOUNT || 0).format("0,000.00"),
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: numeral(data[i]?.DEFAULT_INTEREST || 0).format("0,000.00"),
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: numeral(data[i]?.COLLECTION_FEE || 0).format("0,000.00"),
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "ลำดับที่",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "วันที่กู้",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "ครบกำหนด",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "รับชำระ",
          width: { wch: 16 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "ชื่อ",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "เลขที่สัญญา",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "ประเภทรถ",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "จำนวนเงิน",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "เงินต้น",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "ดอกเบี้ย",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "ดอกเบี้ยผิดนัด",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "ค่าทวงถาม",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(payments),
    },
  ];

  return (
    <div>
      <Button
        disabled={loading}
        loading={loading}
        onClick={fetchLeasingLoan}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
      >
        {loading ? `Loading... ${count}` : "Report Payment"}
      </Button>

      <ExcelFile
        filename={`LEASING_PAYMENT_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-leasing-payment" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="Payment"></ExcelSheet>
      </ExcelFile>
    </div>
  );
}

export default LeasingReportPayment;
